export default __webpack_public_path__ + "locales/ar-SA/CreateEditRoomDialog.json?hash=200c81da0ba3fbccd0df64c715736307";